/**
 * Market-scoped localStorage helpers.
 *
 * Every Solo-checkout localStorage key embeds the active admin's market_id
 * so two cashiers signed in to different markets on the same browser can't
 * read each other's parked carts, last-recipient emails, etc.
 *
 * Falls back gracefully (no-op / null) when storage is unavailable
 * (Safari private mode, quota exceeded).
 */

function _scopedKey (namespace, marketId) {
  return `${namespace}:${marketId || 'unknown'}`
}

export function readScoped (namespace, marketId, fallback = null) {
  try {
    const raw = window.localStorage.getItem(_scopedKey(namespace, marketId))
    if (raw === null) return fallback
    return JSON.parse(raw)
  } catch (e) {
    return fallback
  }
}

export function writeScoped (namespace, marketId, value) {
  try {
    window.localStorage.setItem(_scopedKey(namespace, marketId), JSON.stringify(value))
  } catch (e) {
    /* silent: storage full / disabled */
  }
}

export function clearScoped (namespace, marketId) {
  try {
    window.localStorage.removeItem(_scopedKey(namespace, marketId))
  } catch (e) {
    /* silent */
  }
}
